module.exports = __webpack_public_path__ + "static/ecommerce-481b68b31b20894b10dedc7bcce9c1bf.png";